import { createFileRoute } from "@tanstack/react-router";

import MeqLiveAdmin from "~/pages/MeqLiveAdmin";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/meq-live-admin")({
  staticData: ROUTE_STATIC.meqLiveAdmin,
  component: MeqLiveAdmin,
});
